import { render, staticRenderFns } from "./SlideDeckManageResources.vue?vue&type=template&id=318fa074"
import script from "./SlideDeckManageResources.vue?vue&type=script&lang=ts"
export * from "./SlideDeckManageResources.vue?vue&type=script&lang=ts"
import style0 from "./SlideDeckManageResources.vue?vue&type=style&index=0&id=318fa074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports